import { useCallback, useRef } from 'react';

/**
 * Selects the inner text of an input when clicked into.
 * Removes the full selection if clicked into a second time, as this indicates
 * the user wants to edit a part of the value rather than the entire value.
 * Works cross-browser.
 */
export default function useSelectInnerText() {
	const focusedRef = useRef<string>(null);

	const handleClick = useCallback((e: React.MouseEvent<HTMLInputElement>) => {
		if (focusedRef.current === e.currentTarget.name) return;

		e.currentTarget.select();
		focusedRef.current = e.currentTarget.name;
	}, []);

	const handleBlur = useCallback(() => {
		focusedRef.current = null;
	}, []);

	return [handleClick, handleBlur] as const;
}
